import React from 'react';
import { LayoutChangeEvent, View } from 'react-native';

import { height } from '../../style-utils';
// @ts-ignore
import VimeoVideo from './vimeo-video';
import type { VimeoPlayerProps } from './vimeo-video-props';

export const VimeoPlayer = ({
  src,
  ratio,
  autoplay,
  autopause,
  loop,
}: VimeoPlayerProps) => {
  const [size, setSize] = React.useState<{ width: number; height: number }>();

  if (!src) {
    return null;
  }

  let _src = src;
  if (autoplay) {
    _src += '&autoplay=1';
  }

  if (autopause) {
    _src += '&autopause=1';
  }

  if (loop) {
    _src += '&loop=1';
  }

  const onContainerLayout = (e: LayoutChangeEvent) =>
    setSize({
      width: e.nativeEvent.layout.width,
      height: e.nativeEvent.layout.width / ratio,
    });

  return (
    <View onLayout={onContainerLayout} style={[height(size?.height)]}>
      {!!size && (
        <VimeoVideo src={_src} width={size?.width} height={size?.height} />
      )}
    </View>
  );
};
